module.exports = __webpack_public_path__ + "static/media/prescription-bottle.33908646.svg";